import axios from "../../axios";

export async function logoutUser() {
  try {
    await axios.get('/logout');
    window.dispatchEvent(new Event('session-expired')); // Optional: trigger logout globally
    return true;
  } catch (err) {
    console.error('Logout failed:', err);
    return false;
  }
}

export function logoutUserOn401() {
  window.dispatchEvent(new Event('session-expired'));
}